module.exports = __webpack_public_path__ + "static/media/Pramod.c6e903f0.jpg";